import styled from 'styled-components'
import TipTracker from '../../components/TipTracker'

const StyledTipTracker = styled(TipTracker)`
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;
`

export default StyledTipTracker



// WEBPACK FOOTER //
// ./src/pages/bedroom/_StyledTipTracker.js